// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.top-reps-wrapper {
    position: relative;
    width: 100vw;

    background-color: #e4eefc;
    
}

.top-reps-background {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #e4eefc;
    z-index: -1;
}

.top-reps-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    max-width: 1512px;
    margin: 0 auto;
    height: 1170px;
}

.top-reps-container .section-title {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 109px;
    width: 90%;
}

.top-reps-container .heading {
    color: var(--blue, #458BEA);
    text-align: center;
    font-family: Georgia;
    font-size: 50px;
    font-style: normal;
    font-weight: 700;
    line-height: 120%; /* 60px */
    width: 100%;
}

.top-reps-container p {
    color: var(--primitive-gray);
    font-size: 22px;
    font-weight: 400;
    line-height: 33px;
    text-align: center;
    margin-top: 20px;

   
}

.top-reps-container .gallery{
    overflow-x: scroll;
    max-width: 1512px;
    margin-top: 50px;
    width: 100%


}

@media (max-width: 1224px) {
    .top-reps-container {
        width: 100%;
        height: auto;
        padding: 20px;
        flex-shrink: 0;
        height: 900px;
    }

    .top-reps-container .section-title {
        width: 100%;
        margin-bottom: 10px;
    }

    .top-reps-container .heading {
        font-size: 24px;
        margin-bottom: 10px;
        color: var(--blue, #458BEA);
        font-family: Georgia;
        font-size: 40px;
        line-height: 120%; /* 48px */
    }

    .top-reps-container .section-title  p {
        font-size: 16px;
        margin-bottom: 20px;

    }

    .top-reps-container .gallery{


    }
}
`, "",{"version":3,"sources":["webpack://./src/components/TopReps/style.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,YAAY;;IAEZ,yBAAyB;;AAE7B;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,UAAU;AACd;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,SAAS;IAC5B,WAAW;AACf;;AAEA;IACI,4BAA4B;IAC5B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;;;AAGpB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB;;;AAGJ;;AAEA;IACI;QACI,WAAW;QACX,YAAY;QACZ,aAAa;QACb,cAAc;QACd,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,mBAAmB;QACnB,2BAA2B;QAC3B,oBAAoB;QACpB,eAAe;QACf,iBAAiB,EAAE,SAAS;IAChC;;IAEA;QACI,eAAe;QACf,mBAAmB;;IAEvB;;IAEA;;;IAGA;AACJ","sourcesContent":[".top-reps-wrapper {\n    position: relative;\n    width: 100vw;\n\n    background-color: #e4eefc;\n    \n}\n\n.top-reps-background {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: #e4eefc;\n    z-index: -1;\n}\n\n.top-reps-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    max-width: 1512px;\n    margin: 0 auto;\n    height: 1170px;\n}\n\n.top-reps-container .section-title {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    height: 109px;\n    width: 90%;\n}\n\n.top-reps-container .heading {\n    color: var(--blue, #458BEA);\n    text-align: center;\n    font-family: Georgia;\n    font-size: 50px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 120%; /* 60px */\n    width: 100%;\n}\n\n.top-reps-container p {\n    color: var(--primitive-gray);\n    font-size: 22px;\n    font-weight: 400;\n    line-height: 33px;\n    text-align: center;\n    margin-top: 20px;\n\n   \n}\n\n.top-reps-container .gallery{\n    overflow-x: scroll;\n    max-width: 1512px;\n    margin-top: 50px;\n    width: 100%\n\n\n}\n\n@media (max-width: 1224px) {\n    .top-reps-container {\n        width: 100%;\n        height: auto;\n        padding: 20px;\n        flex-shrink: 0;\n        height: 900px;\n    }\n\n    .top-reps-container .section-title {\n        width: 100%;\n        margin-bottom: 10px;\n    }\n\n    .top-reps-container .heading {\n        font-size: 24px;\n        margin-bottom: 10px;\n        color: var(--blue, #458BEA);\n        font-family: Georgia;\n        font-size: 40px;\n        line-height: 120%; /* 48px */\n    }\n\n    .top-reps-container .section-title  p {\n        font-size: 16px;\n        margin-bottom: 20px;\n\n    }\n\n    .top-reps-container .gallery{\n\n\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
